import React from 'react';

export type ButtonProps = {
    onClick: (
        event: React.FormEvent<HTMLButtonElement>,
        isBusy: boolean
    ) => void;
    waitValue?: boolean;
    waitOnClick?: boolean;
    className?: string;
    text: string;
    name?: string;
    waitText?: string;
    id?: string;
    disabled?: boolean;
};

/** A custom button component that allows a timer when clicked */
const Button = ({
    id,
    text,
    waitValue = false,
    waitText = '',
    waitOnClick = true,
    onClick,
    className = 'btn btn-primary',
    name,
    disabled
}: ButtonProps) => {
    const handleClick = (event: React.FormEvent<HTMLButtonElement>) => {
        event.preventDefault();
        let isBusy = false;

        if (waitOnClick) {
            isBusy = true;
        }

        onClick(event, isBusy);
    };

    let wrapperClassName = className;
    wrapperClassName += waitValue || disabled ? ' disabled' : '';

    let buttonControl = (
        <button
            id={id}
            onClick={handleClick}
            className={wrapperClassName}
            aria-label={name}
            disabled={waitValue || disabled}>
            {text}
        </button>
    );

    const showWaiting = waitOnClick && waitValue;

    if (showWaiting) {
        buttonControl = (
            <button
                className={className}
                aria-label={name}
                disabled={waitValue || disabled}
                id={id}>
                <span
                    className='spinner-border spinner-border-sm mr-2'
                    role='status'
                    aria-hidden='true'
                    style={{ marginRight: '0.5rem' }}
                />
                {waitText || ''}
            </button>
        );
    }

    return <>{buttonControl}</>;
};

export default Button;
